import { ReactElement, useId } from 'react';
import { Svg } from './styles';

interface CelsiusAiMarkProps {
  size?: number | string;
  white?: boolean;
  spin?: boolean;
}

// Desenhos do símbolo Celsius AI 2027 (gradiente e negativo), como entregues pelo Marketing.
// Os dois arquivos vêm com o desenho em posições diferentes no quadro 132x132
// (gradiente centrado em 68,66; negativo em 67,63). As translações abaixo levam
// ambos ao centro do quadro (66,66) sem mexer nos paths, para as variações
// ocuparem o mesmo lugar e o símbolo girar sem oscilar no estado carregando.
const GRADIENT_CENTERING = 'translate(-2 0)';
const WHITE_CENTERING = 'translate(-1 3)';
const GRADIENT_PATH = 'M68 4.80005C68 56.82 75.956 61.4033 120.999 35.4C75.956 61.4033 75.956 70.5968 120.999 96.6001C75.956 70.5968 68 75.18 68 127.2C68 75.18 60.044 70.5968 15.0008 96.6001C60.044 70.5968 60.044 61.4033 15.0008 35.4C60.044 61.4033 68 56.82 68 4.80005Z';
const WHITE_PATH = 'M66.9999 1.80005C66.9999 53.82 74.9559 58.4033 119.999 32.4C74.9559 58.4033 74.9559 67.5968 119.999 93.6001C74.9559 67.5968 66.9999 72.1801 66.9999 124.2C66.9999 72.1801 59.0439 67.5968 14.0007 93.6001C59.0439 67.5968 59.0439 58.4033 14.0007 32.4C59.0439 58.4033 66.9999 53.82 66.9999 1.80005Z';

export const CelsiusAiMark = ({
  size = 24,
  white = false,
  spin = false,
}: Readonly<CelsiusAiMarkProps>): ReactElement => {
  // Ids por instância: vários símbolos na mesma tela não podem compartilhar gradiente nem recorte.
  const uid = useId().replace(/:/g, '');
  const fillGradientId = `cai-fill-${uid}`;
  const strokeGradientId = `cai-stroke-${uid}`;
  const clipId = `cai-clip-${uid}`;

  return (
    <Svg width={size} height={size} viewBox="0 0 132 132" fill="none" $spin={spin}>
      <g clipPath={`url(#${clipId})`}>
        {white ? (
          <path
            transform={WHITE_CENTERING}
            d={WHITE_PATH}
            fill="white"
            stroke="white"
            strokeWidth="2.72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        ) : (
          <path
            transform={GRADIENT_CENTERING}
            d={GRADIENT_PATH}
            fill={`url(#${fillGradientId})`}
            stroke={`url(#${strokeGradientId})`}
            strokeWidth="2.72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        )}
      </g>
      <defs>
        {white ? null : (
          <>
            <linearGradient id={fillGradientId} x1="15.0008" y1="127.2" x2="15.0008" y2="4.80005" gradientUnits="userSpaceOnUse">
              <stop stopColor="#00B9CE" />
              <stop offset="1" stopColor="#363BC4" />
            </linearGradient>
            <linearGradient id={strokeGradientId} x1="15.0008" y1="127.2" x2="15.0008" y2="4.80005" gradientUnits="userSpaceOnUse">
              <stop stopColor="#00B9CE" />
              <stop offset="1" stopColor="#363BC4" />
            </linearGradient>
          </>
        )}
        <clipPath id={clipId}>
          <rect width="131.592" height="131.592" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
};
